import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { ReactComponent as LubavLogoWithText } from '@backrs_ui/common-ui/src/assets/images/lubav-logo-with-text.svg';
import { ReactComponent as LubavLogo } from '@backrs_ui/common-ui/src/assets/images/lubav-logo.svg';
import { ReactComponent as ProsperLogo } from '@backrs_ui/common-ui/src/assets/images/prosper-logo.svg';
import { Box, Drawer, List } from '@mui/material';
import { PageShellNavMenuItem } from './PageShellNavMenuItem';
var DRAWER_WIDTH_COLLAPSED = 80;
var DRAWER_WIDTH_EXPANDED = 260;
export var BackrsPageShellWrapper = function (_a) {
    var application = _a.application, onApplicationLogoClick = _a.onApplicationLogoClick, children = _a.children, topMenuItems = _a.topMenuItems, bottomMenuItems = _a.bottomMenuItems;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var prosperLogo = _jsx(ProsperLogo, {});
    var lubavLogo = isOpen ? _jsx(LubavLogoWithText, {}) : _jsx(LubavLogo, {});
    var isProsper = application === 'PROSPER';
    return (_jsxs(_Fragment, { children: [_jsxs(Drawer, { variant: "permanent", onMouseOver: function () { return setIsOpen(true); }, onMouseLeave: function () { return setIsOpen(false); }, sx: getDrawerStyle(isOpen), children: [_jsxs(Box, { children: [_jsxs(Box, { ml: isProsper ? 3 : 2, sx: { cursor: 'pointer' }, onClick: onApplicationLogoClick, children: [isProsper && prosperLogo, !isProsper && lubavLogo] }), !!(topMenuItems === null || topMenuItems === void 0 ? void 0 : topMenuItems.length) && (_jsx(List, { children: topMenuItems.map(function (item) { return (_jsx(PageShellNavMenuItem, { label: item.label, leftIcon: {
                                        icon: item.icon,
                                        iconColor: item.isActive ? appColors.color.blue1 : appColors.color.blue2,
                                        alt: item.label,
                                    }, isActive: item.isActive, isExpanded: isOpen, onClick: item.onClick }, item.label)); }) }))] }), _jsx(List, { sx: { mb: 3 }, children: bottomMenuItems.map(function (item) { return (_jsx(PageShellNavMenuItem, { label: item.label, leftIcon: {
                                icon: item.icon,
                                alt: item.label,
                                iconWidth: item.iconWidth,
                            }, rightIcon: item.rightIcon && {
                                icon: item.rightIcon,
                                alt: item.label,
                                onRightIconClick: item.onRightIconClick,
                            }, isExpanded: isOpen, onClick: item.onClick }, item.label)); }) })] }), _jsx(Box, { sx: childrenContainerStyle, children: children })] }));
};
var getDrawerStyle = function (isOpen) { return ({
    width: isOpen ? DRAWER_WIDTH_EXPANDED : DRAWER_WIDTH_COLLAPSED,
    backgroundColor: appColors.color.taupe1,
    '& .MuiDrawer-paper': {
        justifyContent: 'space-between',
        display: 'flex',
        width: isOpen ? DRAWER_WIDTH_EXPANDED : DRAWER_WIDTH_COLLAPSED,
        borderWidth: 0,
        overflowX: 'hidden',
        backgroundColor: appColors.color.taupe1,
        transition: "width ".concat(isOpen ? '300ms ease-out' : '75ms ease-in'),
        boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.14)',
        pt: 2,
    },
}); };
var childrenContainerStyle = {
    flexGrow: 1,
    marginLeft: "".concat(DRAWER_WIDTH_COLLAPSED, "px"),
};
